module.exports = __webpack_public_path__ + "static/10-7dbbda3b65aea094c93a0021b5236c4d.jpg";